import { Cart, CartItem } from "./types";

export interface CartState {
  error?: Error & {
    isHidden?: boolean;
  };
  isLoading: boolean;
  isMerging: boolean;
  changeCartOnMerge: boolean;
  fetchingCart?: boolean;
  isRedirecting: boolean;
  cart?: Cart;
  isCartOpen?: boolean;
  geoLocRegion?: string;
  soldOutProducts?: Array<CartItem>;
  isSilentProcessing?: boolean;
}

export const initialCartState: CartState = {
  isMerging: false,
  changeCartOnMerge: false,
  isLoading: false,
  fetchingCart: false,
  isRedirecting: false,
  isCartOpen: false,
  geoLocRegion: "",
  isSilentProcessing: false,
};
